<div class="payment-integration-outer">
  <div class="form-outer">
    <form class="form" [formGroup]="form" autocomplete="off" (ngSubmit)="onSubmit()">
      <div class="col">
        <div class="form__group">
          <label class="form__label">Enable Payment Integration</label>
          <small>Toggle to activate/deactivate Payment integration.</small>
        </div>

        <div class="form__group">
          <div class="radios">
            <span class="form__radio-outer">
              <p-radioButton
                name="enablePaymentIntegration"
                value="True"
                inputId="EnablePaymentIntegrationYes"
                formControlName="enablePaymentIntegration"
              ></p-radioButton>
              <label class="radio-button-text" for="EnablePaymentIntegrationYes">Yes</label>
            </span>
            <span class="form__radio-outer">
              <p-radioButton
                name="enablePaymentIntegration"
                value="False"
                inputId="EnablePaymentIntegrationNo"
                formControlName="enablePaymentIntegration"
              ></p-radioButton>
              <label class="radio-button-text" for="EnablePaymentIntegrationNo">No</label>
            </span>
          </div>

          <div class="invalid-feedback" *ngIf="form.get('enablePaymentIntegration').touched && form.get('enablePaymentIntegration').invalid">
            Please select Yes or No.
          </div>
        </div>

        <ng-container *ngIf="form.get('enablePaymentIntegration')?.value === 'True'">
          <div class="form__group">
            <label class="form__label">Fallback Fixed Charge ($)</label>
            <input type="text" class="form__control" pInputText formControlName="fixAmount" />
            <small
              >The fixed amount to charge the patient only if the primary source is empty or not available. This ensures a minimum payment is always attempted.</small
            >
            <div class="invalid-feedback" *ngIf="form.get('fixAmount').touched && form.get('fixAmount').invalid">Fallback Fixed Charge is required.</div>
          </div>

          <div class="form__group">
            <label class="form__label">Amount to Collect - Override Policy</label>
            <p-select
              class="form__dropdown select-box"
              formControlName="amountToCollectSource"
              [options]="amountToCollectModeOptions"
              placeholder="Select"
              optionLabel="name"
              optionValue="code"
            ></p-select>
            <small>Determines if the user can manually adjust the "Amount to Collect" field on the Main Module S/O page.</small>
          </div>

          <div class="form__group">
            <label class="form__label">Exclude Insurance</label>
            <p-multiSelect
              class="form__multiSelect select-box"
              formControlName="excludeInsurance"
              [options]="insuranceOptions"
              placeholder="Select"
              optionLabel="name"
              optionValue="value"
            ></p-multiSelect>
            <small>Conditions to exclude specific insurance carriers from payment collection logic.</small>
          </div>

          <div class="form__group">
            <label class="form__label">Exclude Classification</label>
            <p-multiSelect
              class="form__multiSelect select-box"
              formControlName="excludeClassification"
              [options]="classificationOptions"
              placeholder="Select"
              optionLabel="name"
              optionValue="value"
            ></p-multiSelect>
            <small>Classification of sales orders that require payment exclusion.</small>
          </div>

          <div class="full-width-separator"></div>

          <div class="form__group">
            <label class="form__label">Patient Portal - Payment Mode</label>
            <p-select
              class="form__dropdown select-box"
              formControlName="patientPortalSource"
              [options]="patientPaymentModes"
              placeholder="Select"
              optionLabel="name"
              optionValue="code"
            ></p-select>
            <small>Controls the specific patient experience during self-scheduling</small>
          </div>

          <!-- <div class="form__group">
            <label class="form__label">AutoPay Consent</label>
            <div class="radios">
              <span class="form__radio-outer">
                <p-radioButton name="enableAutoPayConsent" value="True"
                  inputId="EnableAutoPayConsentYes" formControlName="enableAutoPayConsent"></p-radioButton>
                <label class="radio-button-text" for="EnableAutoPayConsentYes">Yes</label>
              </span>
              <span class="form__radio-outer">
                <p-radioButton name="enableAutoPayConsent" value="False"
                  inputId="EnableAutoPayConsentNo" formControlName="enableAutoPayConsent"></p-radioButton>
                <label class="radio-button-text" for="EnableAutoPayConsentNo">No</label>
              </span>
            </div>
            <small>Enables capture of patient consent for future auto-debits on the online form while collecting payment. </small>
          </div> -->
          <div class="form__group" *ngIf="form.get('patientPortalSource')?.value != PatientPaymentMode.NO_PAYMENT">
            <label class="form__label">Consent Text</label>
            <textarea class="form__textarea" pInputTextarea maxlength="100" formControlName="autoPayConsentText"></textarea>
            <small>Enter text to display on the payment screen.</small>
          </div>

          <div class="form__group">
            <label class="form__label">Enable Cancellation Fee</label>
            <div class="radios">
              <span class="form__radio-outer">
                <p-radioButton value="True" name="enableCancellationFee" inputId="EnableCancellationFeeYes" formControlName="enableCancellationFee"></p-radioButton>
                <label class="radio-button-text" for="EnableCancellationFeeYes">Yes</label>
              </span>
              <span class="form__radio-outer">
                <p-radioButton value="False" name="enableCancellationFee" inputId="EnableCancellationFeeNo" formControlName="enableCancellationFee"></p-radioButton>
                <label class="radio-button-text" for="EnableCancellationFeeNo">No</label>
              </span>
            </div>
            <small>Activates the last-minute cancellation fee policy.</small>
          </div>

          <div class="form__group" *ngIf="form.get('enableCancellationFee')?.value === 'True'">
            <label class="form__label">Cancellation Window (Hours)</label>
            <input type="text" class="form__control" pInputText formControlName="cancellationWindow" />
            <small>Time window during which cancellation incurs the fee.</small>
          </div>

          <div class="form__group" *ngIf="form.get('enableCancellationFee')?.value === 'True'">
            <label class="form__label">Cancellation Fee Amount ($)</label>
            <input type="text" class="form__control" pInputText formControlName="cancellationFeeAmount" />
            <small>The fee charged for late cancellation.</small>
          </div>

          <div class="form__group" *ngIf="form.get('enableCancellationFee')?.value === 'True'">
            <label class="form__label">Cancellation Consent Text</label>
            <textarea class="form__textarea" pInputTextarea formControlName="cancellationConsentText" maxlength="100"></textarea>
            <small>Enter text to display on the payment screen.</small>
          </div>
        </ng-container>
      </div>

      <div class="btns">
        <button class="btn btn--primary" type="submit" [disabled]="loading">Save</button>
        <button class="btn btn--secondary" routerLink="/admin/settings">Cancel</button>
      </div>
    </form>
  </div>
</div>
<div class="loader-block" *ngIf="loading">
  <p-progressSpinner [style]="{ width: '50px', height: '50px' }" strokeWidth="8" fill="#ffffff" animationDuration=".8s"> </p-progressSpinner>
</div>
